import React from "react";
import { Link } from "react-router-dom";

const DEFAULT_SUBHEAD = "The Constanța tech scene gets louder when its people share its work. Pick a post.";

const FeedHeader = ({ track }) => {
    const subhead = (track && track.subhead) || DEFAULT_SUBHEAD;

    return (
        <header className="bg-white border-b border-brand-panel">
            <div className="max-w-7xl mx-auto px-6 sm:px-8 py-8 sm:py-12 lg:py-14">
                <div className="mb-5 sm:mb-6">
                    <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-brand-muted hover:text-brand-ink transition-colors">
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                        All tracks
                    </Link>
                </div>
                <h1 className="flex flex-wrap items-center gap-x-4 sm:gap-x-5 gap-y-2 font-brand text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-brand-ink leading-[1.05]">
                    <Link
                        to="/"
                        aria-label="Home"
                        className="inline-flex items-center"
                    >
                        <img
                            src="/ambasada-mark.svg"
                            alt="Ambasada"
                            width="40"
                            height="40"
                            className="h-12 sm:h-14 lg:h-16 w-auto"
                        />
                    </Link>
                    <span>community<span className="text-brand-red">.</span></span>
                </h1>
                <p className="mt-4 text-base sm:text-lg text-brand-muted max-w-xl">
                    {subhead}
                </p>
                <div className="mt-5 h-1 w-24 bg-brand-red rounded-full" />
            </div>
        </header>
    );
};

export default FeedHeader;
